import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { CameraIcon } from '../Icons/CameraIcon';

interface IProps {
  className?: string;
  placeholderIcon?: ReactNode;
}

export const NextImagePlaceholder = ({
  className = '',
  placeholderIcon = (
    <div className="bg-disabled rounded-sm p-3">
      <CameraIcon />
    </div>
  ),
}: IProps) => (
  <div
    className={twMerge(
      `bg-twilight text-lake-fog absolute top-0 left-0 flex h-full w-full items-center justify-center p-4`,
      className,
    )}
  >
    {placeholderIcon}
  </div>
);
